/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";

import { Link } from "react-router-dom";

import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import useAppMRT from "hooks/useAppMRT";

const FIELD_TO_PARAM = {
  title: "title",
  slug: "slug",
  isreservedstring: "isreservedstring",
  moderatorname: "moderatorname",
  labeldate: "labeldate",
};

const LabelList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation
  const appMRTProps = useAppMRT();

  const {
    reloadLabelList,
    setReloadLabelList,
    setEditLabelData,
    screenHeight,
  } = useContext(GlobalProvider);

  const [labelList, setLabelList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);
  const searchTimer = useRef(null);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return labelList.filter((item) => selectedIds.includes(item._id));
  };

  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : labelList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Label.xlsx");
  };

  /* function to get all label data */
  const getAllLabelList = async (currentSearch = search, currentColumnFilters = columnFilters) => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASEURL + url.API_MANAGE_TAGS + `?token=${token}`;

      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }
      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });

      console.log("reserve list url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("label list response ========>>>", response);

      if (response.data) {
        setLabelList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <div className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.title}</span>
          <Link
            to="#addUpdateLabelPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditLabelData(dataItem);
              }}
            >
              edit
            </span>
          </Link>
        </div>
      </div>
    );
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "title",
        accessorKey: "title",
        header: t("Title"),
        Cell: ({ row }) => titleHtml({ dataItem: row.original }),
        size: 200,
      },
      {
        id: "slug",
        accessorKey: "slug",
        header: t("Slug"),
        size: 200,
      },
      {
        id: "isreservedstring",
        accessorKey: "isreservedstring",
        header: t("Reserved"),
        size: 120,
      },
      {
        id: "moderatorname",
        accessorKey: "moderatorname",
        header: t("Moderator"),
        size: 200,
      },
      {
        id: "labeldate",
        accessorKey: "labeldate",
        header: t("Date"),
        size: 200,
      },
    ],
    [t, labelList]
  );

  /* hook to reload list */
  useEffect(() => {
    if (reloadLabelList || !responseReceived) {
      getAllLabelList();
      if (reloadLabelList) {
        setReloadLabelList(false);
      }
    }
  }, [reloadLabelList, responseReceived]);

  /* hook to hit  exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records based on labelList */
  useEffect(() => {
    setRecords(labelList.length);
  }, [labelList]);

  /* search bar — debounced API call */
  useEffect(() => {
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      getAllLabelList(search, columnFilters);
    }, 500);
  }, [search]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllLabelList(search, columnFilters);
    }, 500);
  }, [columnFilters]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, labelList]);

  return (
    <div className="table-responsive">
      {/* Hidden checkboxes so LabelHeader can detect selected rows via name="selectLabelRecord" */}
      <div style={{ display: "none" }}>
        {labelList.map((item) => (
          <input
            key={item._id}
            type="checkbox"
            name="selectLabelRecord"
            value={item._id}
            checked={!!rowSelection[item._id]}
            onChange={() => {}}
          />
        ))}
      </div>
      {/* ========= MaterialReactTable start ======= */}
      <MaterialReactTable
        {...appMRTProps}
        columns={tableColumns}
        data={labelList}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        manualFiltering
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={setColumnFilters}
        getRowId={(row) => row._id}
        state={{ rowSelection, columnFilters, isLoading }}
        muiCircularProgressProps={{ style: { display: "none" } }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
      {/* ========= MaterialReactTable end ======= */}
    </div>
  );
};

export default LabelList;
